import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IGatewayRepository } from '../../repositories/interfaces/iGatewayRepository';
import { IGatewayLanguageResponse } from '../../../entity/interface/iGatewayLanguage';
import { JsonType } from '@intigral/types';

export interface IGetGatewayLanguageUseCase {
    execute(appKey: string, language: string): Promise<JsonType>;
}

export class GetGatewayLanguageUseCase implements IGetGatewayLanguageUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get gatewayRepository(): IGatewayRepository {
        return container.resolve<IGatewayRepository>(DI.REPOSITORIES.IGatewayRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(appKey: string, language: string): Promise<JsonType> {
        const response = await this.gatewayRepository.getGatewayLanguage(appKey, language);
        return response;
    }
}
